import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageICARProblems() {
   const ALL_OPTS = { value: 0, label: "-- Select --", active: false };
   const ICAR_MODEL = { value: 0, label: "", active: true };
   const [icarPblm, setIcarPblm] = useState(ICAR_MODEL);
   const [icarList, setIcarList] = useState([]);
   const [editProblem, setEditProblem] = useState("");
   const [newProblem, setNewProblem] = useState("");
   const [origProblem, setOrigProblem] = useState("");
   const [spinIcarPblm, setSpinIcarPblm] = useState(true);
   const [filters, setFilters] = useState([
      { filterName: "problem", value: ALL_OPTS }
   ]);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!icarPblm || icarPblm.value === 0)
         return; // problem was reset to initial state

      if (!editProblem || editProblem.length < 1)
         return; // Not editing       

      if (icarPblm.label === origProblem)
         return; // No change made to problem being edited

      if (icarPblm.label.length < 3) { // Do we need this?
         toast.error("Problem description must be at least 3 characters");
         return;
      }
      updateIcarPblm();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [icarPblm])

   function activateIcarProblem() {
      if (!icarPblm || icarPblm.value === 0) {
         toast.error("Please select a problem type to activate");
         return;
      }

      setSpinIcarPblm(true);
      api.post(`Quality/ActivateICarProblem/${icarPblm.value}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem type activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinIcarPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinIcarPblm(false);
         });
   }

   function deleteIcarProblem() {
      setSpinIcarPblm(true);
      api.post(`Quality/DeleteICarProblem/${icarPblm.value}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem type was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinIcarPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinIcarPblm(false);
         });
   }

   function onIcarProblemChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewProblem(""); // Clear any lingering values
      if (newFilterValue.value === 0) {
         setIcarPblm(ICAR_MODEL);
         setOrigProblem("");
         setEditProblem("");
      }
      else { // Get the problem to be edited
         const d = _.find(icarList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, icarPblm);
         changes.label = newFilterValue.label;
         changes.active = d.active;
         changes.value = newFilterValue.value;
         setIcarPblm(changes);
         setOrigProblem(newFilterValue.label);
         setEditProblem(newFilterValue.label);
      }
   }

   function onIcarPblmUpdate() {
      let changes = Object.assign({}, icarPblm);
      changes.label = editProblem
      setIcarPblm(changes);
   }

   function runQuery() {
      setSpinIcarPblm(true);
      api
         .fetch(`Quality/LoadInternalActionProblems`)
         .then((response) => {
            if (response.data.success) {
               const dfList = _.concat([ALL_OPTS],
                  _.map(response.data.list, (d) => ({
                     value: d.value,
                     label: d.label,
                     active: d.active
                  })));
               return { dfList: dfList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ dfList }) => {
            setIcarList(dfList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditProblem("");
            setOrigProblem("");
            setNewProblem("")
            setIcarPblm(ICAR_MODEL);
            setSpinIcarPblm(false);
         });
   }

   function saveNewIcarPblm() {
      if (!newProblem || newProblem.length < 1) {
         toast.error("Please provide a problem description");
         return;
      }
      if (newProblem.length < 3) {
         toast.error("Problem description must be at least 3 characters");
         return;
      }
      let payload = Object.assign({}, ICAR_MODEL);
      payload.label = newProblem;

      setSpinIcarPblm(true);
      api.post('Quality/SaveICarProblem', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem type created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinIcarPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinIcarPblm(false);
         });
   }

   function updateIcarPblm() {
      setSpinIcarPblm(true);
      api.post('Quality/SaveICarProblem', icarPblm)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem type updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinIcarPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinIcarPblm(false);
         });
   }

   const showDeleteModal = () => {
      if (!icarPblm || icarPblm.value === 0) {
         toast.error("Please select a problem");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editProblem} problem type?`,
         buttons: [
            { label: "Yes", onClick: () => { deleteIcarProblem() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinIcarPblm}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {icarList && icarList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Problem:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="problem"
                                             options={icarList}
                                             value={filterHelpers.getValue(filters, "problem")}
                                             onChangeCallback={e => onIcarProblemChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>

                     {icarPblm && icarPblm.value > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a problem type that has internal corrective actions attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive problem types will show on internal action edit page, but will be unable to be selected. They show only for the sake of history records that might need it.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {icarPblm.value}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {icarPblm.active ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Problem:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editProblem || ""}
                                             onChange={(e) => setEditProblem(e.target.value)}
                                             maxLength="100"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onIcarPblmUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => showDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       {!icarPblm.active && icarPblm.value !== 0 ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => activateIcarProblem()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     <br />
                     <br />
                     <hr />
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           Add New Problem Type
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Problem:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newProblem || ""}
                                          onChange={(e) => setNewProblem(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Problem"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => saveNewIcarPblm()}
                                       >
                                          Add Problem
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
